
<!--
  NOTE: select element id is set in soho-dropdown.component.ts via setting the name attribute
  todo: if there are issues with id then check the soho-dropdown.component to verify it's still
   setting the id from the name attribute.
-->


<label
    attr.for="{{id}}"
    *ngIf="!isCompoundFieldMember && showLabel"
    soho-label
    [required]="required$ | async"
    lm-label
    [layoutField] = "field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
    (click)="onCompoundFieldClickEvent($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>

<!--
<ng-container [ngSwitch]="formType">
  <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
-->

<ng-container *ngIf="formType === formDisplayType.SEARCH_FORM; else NormalForm">
  <ng-container *ngIf="isCompoundFieldMember; else NormalFieldOnSearchForm">
    <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
    <ng-container *ngIf="lmParagraphLayoutInfo.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else NormalMode"></ng-container>
    <!-- On a search form, just a compound field member NOT in the preview -->
    <ng-template #NormalMode>
      <div
          (focusin)="onFieldFocus($event)"
          (focusout)="onFieldBlur($event)">
        <!-- need a hidden label besides the select inputs to correctly set the aria label -->
        <label
          attr.for="{{id}}"
          soho-label
            audible="true"
        >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
        <ng-container [ngSwitch]="displayType">
          <ng-container *ngSwitchCase="layoutDisplayType.USER_DEFINED">
            <!--          [showSelectAll]="showSelectAll"-->
            <select
                [ngClass]="fieldClassesString"
                name="{{id}}"
                attr.name="{{id}}"
                [attributes]="fieldIdAttributes"
                [attr.bindId]="bindId"
                [readonly]="(readOnly$ | async)"
                [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
                [(ngModel)]="modelField.value"
                soho-dropdown
                [source]="source"
                [reload]="userDefinedReloadType"
                (change)="onChanged($event)"
                soho-busyindicator
                blockUI="true"
                displayDelay="0"
                soho-alert
            >
              <option *ngFor="let item of modelField.states; trackBy: trackByValue" selected="{{item.selected}}" [value]="item.value">{{item.label}}</option>
            </select>
          </ng-container>

          <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
            <select
                [ngClass]="fieldClassesString"
                name="{{id}}"
                attr.name="{{id}}"
                [attributes]="fieldIdAttributes"
                [attr.bindId]="bindId"
                [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
                [readonly]="(readOnly$ | async)"
                [(ngModel)]="modelField.value"
                soho-alert
                soho-dropdown
                multiple
                [compareWith]="compareWithFn"
                [moveSelected]="'all'"
                [showSelectAll]="true"
                [closeOnSelect]="false"
                (change)="onChanged($event)"
                (click)="onChanged($event)"
            >
              <option *ngFor="let item of staticDisplayValues; trackBy: trackByValue" selected={{item.selected}} [value]="item.value">{{item.label}}</option>
            </select>
          </ng-container>

          <ng-container *ngSwitchCase="layoutDisplayType.BOOLEAN">
            <select
                [ngClass]="fieldClassesString"
                name="{{id}}"
                attr.name="{{id}}"
                [attributes]="fieldIdAttributes"
                [attr.bindId]="bindId"
                [readonly]="(readOnly$ | async)"
                [(ngModel)]="modelField.value"
                soho-alert
                soho-dropdown
                (change)="onChanged($event)"
            >
              <option *ngFor="let item of modelField.states; trackBy: trackByValue" [value]="item.value">{{item.label}}&nbsp;</option>
            </select>
          </ng-container>
        </ng-container>

        <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
        <ng-container *ngIf="true; then CompoundPlaceHolderDisplayNormalMode"></ng-container>
      </div>
    </ng-template>
  </ng-container>
  <!-- On a search form, NOT a compound member field-->
  <ng-template #NormalFieldOnSearchForm>
    <!-- need a hidden label besides the select inputs to correctly set the aria label -->
    <label
      attr.for="{{id}}"
      soho-label
      audible="true"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
    <ng-container [ngSwitch]="displayType">
      <ng-container *ngSwitchCase="layoutDisplayType.USER_DEFINED">
        <!--        [showSelectAll]="showSelectAll"-->
        <ng-container *ngIf="showUserDefinedAsMulti; else displaySingle">
          <select
                  [ngClass]="fieldClassesString"
                  name="{{id}}"
                  attr.name="{{id}}"
                  [attributes]="fieldIdAttributes"
                  [attr.bindId]="bindId"
                  [(ngModel)]="modelField.value"
                  soho-alert
                  soho-dropdown
                  multiple
                  [compareWith]="compareWithFn"
                  [moveSelected]="'all'"
                  [showSelectAll]="true"
                  [closeOnSelect]="false"
                  [source]="source"
                  [reload]="userDefinedReloadType"
                  (change)="onChanged($event)"
                  soho-busyindicator
                  blockUI="true"
                  displayDelay="0"
          >
            <option *ngFor="let item of modelField.states; trackBy: trackByValue" [selected]="item.selected" [value]="item.value">{{item.label}}</option>
          </select>
        </ng-container>
        <ng-template #displaySingle>
          <select
                  [ngClass]="fieldClassesString"
                  name="{{id}}"
                  attr.name="{{id}}"
                  [attributes]="fieldIdAttributes"
                  [attr.bindId]="bindId"
                  [(ngModel)]="modelField.value"
                  soho-alert
                  soho-dropdown
                  [source]="source"
                  [reload]="userDefinedReloadType"
                  (change)="onChanged($event)"
                  soho-busyindicator
                  blockUI="true"
                  displayDelay="0"
          >
            <option *ngFor="let item of modelField.states; trackBy: trackByValue" [selected]="item.selected" [value]="item.value">{{item.label}}</option>
          </select>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
        <select
            [ngClass]="fieldClassesString"
            name="{{id}}"
            attr.name="{{id}}"
            [attributes]="fieldIdAttributes"
            [attr.bindId]="bindId"
            [(ngModel)]="modelField.value"
            soho-alert
            soho-dropdown
            multiple
            [compareWith]="compareWithFn"
            [moveSelected]="'all'"
            [showSelectAll]="true"
            [closeOnSelect]="false"
            (change)="onChanged($event)"
            (click)="onChanged($event)"
        >
          <option *ngFor="let item of staticDisplayValues; trackBy: trackByValue" [selected]="item.selected" [value]="item.value" >{{item.label}}</option>
        </select>
      </ng-container>

      <!-- multi select -->
      <ng-container *ngSwitchCase="layoutDisplayType.MULTI">
        <select
            [ngClass]="fieldClassesString"
            name="{{id}}"
            attr.name="{{id}}"
            [attributes]="fieldIdAttributes"
            [attr.bindId]="bindId"
            [(ngModel)]="modelField.value"
            soho-alert
            soho-dropdown
            multiple
            [compareWith]="compareWithFn"
            [maxSelected]="maxSelected"
            [source]="source"
            moveSelected="all"
            [closeOnSelect]="false"
            showSearchUnderSelected="true"
            reload="{{userDefinedReloadType}}"
            (change)="onChanged($event)"
            soho-busyindicator
            blockUI="true"
            displayDelay="0"
        >
          <option *ngFor="let item of modelField.states; trackBy: trackByValue" [selected]="item.selected" disabled="{{item.disabled}}" [value]="item.value">{{item.label}}</option>
        </select>
      </ng-container>

      <ng-container *ngSwitchCase="layoutDisplayType.BOOLEAN">
        <select
            [ngClass]="fieldClassesString"
            name="{{id}}"
            attr.name="{{id}}"
            [attributes]="fieldIdAttributes"
            [attr.bindId]="bindId"
            [(ngModel)]="modelField.value"
            soho-alert
            soho-dropdown
            noSearch
            (change)="onChanged($event)"
        >
          <option *ngFor="let item of modelField.states; trackBy: trackByValue" [value]="item.value">{{item.label}}&nbsp;</option>
        </select>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-container>

<!-- Not on a search form -->
<ng-template #NormalForm>
  <div
      [ngClass]="{'disabled-member-field': disabledMemberField, 'parent-is-compound-field': isCompoundFieldMember}"
      lm-field-options
      [hasContextMenu]="insertContextMenu"
      [dataEntryMode]="dataEntryMode"
      [isMemberField]="isCompoundFieldMember"
      [ajaxCallbackFunction]="onBeforeContextMenuOpen"
      [contextMenuEventFunction]="contextMenuClicked"
      [buttonId]="fieldOptionsId"
      [fieldAutomationId]="fieldAutomationId"
      [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
      [isInAccessibilityMode]="isInAccessibilityMode"
      [displayFieldOptions]="displayFieldOptions"
      lm-layout-util
      [hideWhiteSpace]="!(lmColumnLayoutInfo && lmColumnLayoutInfo.nbrColumns > 1)"
      soho-tooltip
      [popover]="true"
      [title]="popoverTitle"
      [placement]="'right'"
      [trigger]="'click'"
      (focus)="onFocus($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      (contextmenu)="onContextMenu($event)">
    <!-- need a hidden label besides the select inputs to correctly set the aria label -->
    <label
      *ngIf="displayType === layoutDisplayType.PLAIN || displayType === layoutDisplayType.USER_DEFINED || displayType === layoutDisplayType.MULTI"
      attr.for="{{id}}"
      soho-label
      audible="true"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
    <ng-container [ngSwitch]="displayType">
      <!-- single select static -->
      <span *ngIf="showDropDownDirtyIndicator" class="icon-dirty lm-compound-member-field-dirty"></span>
      <select *ngSwitchCase="layoutDisplayType.PLAIN"
          [ngClass]="fieldClassesString"
          name="{{id}}"
          attr.name="{{id}}"
          [attributes]="fieldIdAttributes"
          [attr.bindId]="bindId"
          [readonly]="(readOnly$ | async)"
          [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
          [ngModel]="modelField.valueChanged | async"
          (ngModelChange)="onModelChanged($event)"
          soho-dropdown
          (change)="onChanged($event)"
          (blur)="onBlur($event)"
          soho-alert
          soho-trackdirty
          [searchForm]="onSearchForm"
          (dirty)="onDirty($event)"
          (pristine)="onPristine($event)"
          (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
      >
        <option *ngFor="let item of staticDisplayValues; trackBy: trackByValue" [value]="item.value" [disabled]="item.disabled">{{item.label}}&nbsp;</option>
      </select>

      <!-- single select user defined -->
      <select *ngSwitchCase="layoutDisplayType.USER_DEFINED"
          [ngClass]="fieldClassesString"
          name="{{id}}"
          attr.name="{{id}}"
          [attributes]="fieldIdAttributes"
          [attr.bindId]="bindId"
          [readonly]="(readOnly$ | async)"
          [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
          [ngModel]="modelField.valueChanged | async"
          (ngModelChange)="onModelChanged($event)"
          soho-dropdown
          [reload]="userDefinedReloadType"
          [source]="source"
          (change)="onChanged($event)"
          soho-alert
          soho-trackdirty
          [searchForm]="onSearchForm"
          (dirty)="onDirty($event)"
          (pristine)="onPristine($event)"
          (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
          soho-busyindicator
          blockUI="true"
          displayDelay="0"
      >
        <option *ngFor="let item of modelField.states; trackBy: trackByValue" disabled="{{item.disabled}}" [value]="item.value">{{item.label}}&nbsp;</option>
      </select>

      <!-- multi select -->
      <select *ngSwitchCase="layoutDisplayType.MULTI"
          [ngClass]="fieldClassesString"
          [class.keyMultiSelect]="modelField.isKeyFieldMultiselect"
          name="{{id}}"
          attr.name="{{id}}"
          [attributes]="fieldIdAttributes"
          [attr.bindId]="bindId"
          [readonly]="(readOnly$ | async)"
          [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
          [ngModel]="modelField.valueChanged | async"
          (ngModelChange)="onModelChanged($event)"
          soho-dropdown
          multiple
          [maxSelected]="maxSelected"
          [source]="source"
          moveSelected="all"
          [closeOnSelect]="false"
          showSearchUnderSelected="true"
          reload="{{userDefinedReloadType}}"
          (change)="onChanged($event)"
          soho-alert
          soho-trackdirty
          [searchForm]="onSearchForm"
          (dirty)="onDirty($event)"
          (pristine)="onPristine($event)"
          (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
          soho-busyindicator
          blockUI="true"
          displayDelay="0"
      >
        <option *ngFor="let item of modelField.states; index as i; trackBy: trackByValue" id="i" [selected]="item.selected" [value]="item.value" disabled="{{item.disabled}}">{{item.label}}</option>
      </select>

      <!-- tag -->
      <ng-container *ngSwitchCase="layoutDisplayType.TAG">
        <div
            class="tag-container"
            soho-alert
            lm-field-style
            [fieldStyle]="layoutObject?.fieldStyle"
            [specField]="specField"
            [recalculateStyles]="triggerValueChange | async"
        >
          <span
              attr.id="{{id}}"
              class="tag is-dismissible"
              [ngClass]="{
                'lm-compound-text': isCompoundFieldMember,
                'lm-text-data ': !isCompoundFieldMember,
                'is-active': isFieldTagFocused,
                'is-focused': isFieldTagFocused,
                'hide-focus': !isFieldTagFocused
                }"
              [attr.tabindex]="isInAccessibilityMode ? 0 : null"
              [ngStyle]="{'color': '#FFFFFF', 'outline': 'none'}"
              soho-alert
              lm-field-style
              [fieldStyle]="tagStyle?.style"
              [isTag]="true"
              [recalculateStyles]="triggerValueChange | async"
              (focus)="onTagFocus()"
              (blur)="onTagBlur()"
          >{{modelField.valueChanged | async | stateAsText:modelField.states:true}}</span>
        </div>
      </ng-container>

      <!-- text -->
      <ng-container *ngSwitchCase="layoutDisplayType.TEXT">
        <p
            attr.id="{{id}}"
            [attr.tabindex]="isInAccessibilityMode && !isPreviewCompoundMember ? 0 : null"
            class="hide-white-space"
            [ngClass]="{'lm-compound-text': isCompoundFieldMember, 'lm-text-data ': !isCompoundFieldMember}"
            [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
            lm-field-style
            [fieldStyle]="layoutObject?.fieldStyle"
            [recalculateStyles]="triggerValueChange | async"
        >{{modelField.valueChanged | async | stateAsText:modelField.states}}</p>
      </ng-container>

      <!-- Handle the compound field member display label/value not focused in compact format on a form -->
      <ng-container *ngIf="isCompoundFieldMember">
        <div *ngIf="lmParagraphLayoutInfo?.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else CompoundPlaceHolderDisplayNormalMode"></div>
      </ng-container>

    </ng-container>
  </div>
</ng-template>

<ng-template #CompoundPlaceHolderDisplayNormalMode>
  <p *ngIf="isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField)"
      [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
      attr.id="{{id}}-text"
      [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
      class="lm-compound-text"
      [ngClass]="{'is-placeholder preview-placeholder': true, 'input-style': !(readOnly$ | async)}"
      [ngStyle]="{'display':  showField ? 'none' : 'inline-block'}"
      soho-alert
     (focus)="onFocus($event)"
  >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
</ng-template>

<ng-template #CompoundPlaceHolderDisplayPreviewMode>
  <ng-container *ngIf="!(isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField)); else noValue" >
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text"
        [ngClass]="{'input-style is-placeholder preview-placeholder': true}"
        [ngStyle]="{'display': 'inline-block'}"
        soho-alert
    >{{modelField.valueChanged | async | stateAsText:modelField.states}}</p>
  </ng-container>
  <ng-template #noValue>
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text input-style is-placeholder preview-placeholder"
        [ngStyle]="{'padding-top': isPreviewCompoundMember? '0' : '10px'}"
        soho-alert
    >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  </ng-template>
</ng-template>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>

